import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

// const RNDContext = createDndContext(HTML5Backend);
// const DragAndDropHOC = (props) => {
//   const manager = useRef(RNDContext);
//   return (
//     <DndProvider manager={manager.current.dragDropManager}>
//       {props.children}
//     </DndProvider>
//   );
// };

// export default DragAndDropHOC;
export const withDragDropContext = (
  Component: React.ComponentClass<any> | React.StatelessComponent<any>,
) => {
  return (props: any) => (
    <DndProvider backend={HTML5Backend}>
      <Component {...props} />
    </DndProvider>
  );
};
